/**
 * 그리드 사용자 설정 localStorage
 * key: hr.gridPrefs.{userId}.{gridId}
 *
 * 저장 예:
 * {
 *   hiddenColumns: string[],
 *   freezeToColumnId: string|null,
 *   freezeRowCount: number,
 *   columnSizing: { [columnId]: number },
 *   columnOrder: string[],
 *   mergeEnabled: boolean,
 *   mergeColumnIds: string[],
 *   mergeTouched: boolean,
 *   conditionalRules: object[],
 *   printLayout: object,
 * }
 */

const PREFIX = 'hr.gridPrefs';

function storageKey(gridId, userId) {
  const uid = userId || 'anon';
  const gid = gridId || 'default';
  return `${PREFIX}.${uid}.${gid}`;
}

/**
 * @returns {{
 *   hiddenColumns?: string[],
 *   freezeToColumnId?: string|null,
 *   freezeRowCount?: number,
 *   columnSizing?: Record<string, number>,
 *   columnOrder?: string[],
 *   mergeEnabled?: boolean,
 *   mergeColumnIds?: string[],
 *   mergeTouched?: boolean,
 *   conditionalRules?: object[],
 *   printLayout?: object,
 * }}
 */
export function loadGridPrefs(gridId, userId) {
  if (!gridId || typeof localStorage === 'undefined') return {};
  try {
    const raw = localStorage.getItem(storageKey(gridId, userId));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function saveGridPrefs(gridId, userId, prefs) {
  if (!gridId || typeof localStorage === 'undefined') return;
  try {
    const prev = loadGridPrefs(gridId, userId);
    localStorage.setItem(storageKey(gridId, userId), JSON.stringify({ ...prev, ...prefs }));
  } catch {
    /* ignore quota */
  }
}

/** columnSizing 객체 정규화 (숫자 폭만 유지). 시스템열(No./mod/체크)은 고정폭이라 제외 */
export function normalizeColumnSizing(sizing) {
  if (!sizing || typeof sizing !== 'object' || Array.isArray(sizing)) return {};
  const next = {};
  Object.entries(sizing).forEach(([id, w]) => {
    if (id === 'rowNumber' || id === 'mod' || id === 'rowCheck') return;
    const n = Number(w);
    if (id && Number.isFinite(n) && n > 0) next[id] = Math.round(n);
  });
  return next;
}
